const initState = {
  fetchOtp: {
    success: null,
    error: null,
    code: null,
    message: null,
  },
  validateOtp: {
    success: null,
    error: null,
    code: null,
    message: null,
  },
};

export default initState;
